import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { deleteProfile, getProfiles } from "../actions/profile";
import { getUsers, deleteUser, updateUser } from "../actions/auth";
import TablePagination from "@material-ui/core/TablePagination";
import TableFooter from "@material-ui/core/TableFooter";
import { useMediaQuery } from "@material-ui/core";
import UserRow from "./userRow";
import AdminRow from "./AdminRow";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PropTypes from "prop-types";
import Spinner from "../components/Spinner/Spinner";
import AdminLogin from "./adminLogin/adminLogin";
import ChangePassword from "../components/ChangePassword";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fetchClientsSearch } from "../api";
import { getAllClients } from "../actions/clientActions";

// Pagination table actions
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
// End table pagination actions

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(10),
    },
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
  },
  buttonGroup: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  deviceIdTextField: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "row",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "Top",
      position: "absolute",
      top: theme.spacing(9.5),
      left: theme.spacing(15),
      bottom: theme.spacing(2),
    },
  },
  addButton: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "row",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "Top",
      position: "absolute",
      top: theme.spacing(6.5),
      right: theme.spacing(15),
      bottom: theme.spacing(2),
    },
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "150vh",
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  contentContainer: {
    width: "100%",
    marginRight: theme.spacing(2),
  },
  responsiveContainer: {
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(2),
    },
  },
  tableContainer: {
    overflowX: "auto",
    marginTop: theme.spacing(2),
    borderRadius: "8px",
    overflow: "hidden",
  },
  dialogTitle: {
    backgroundColor: "#1976D2",
    color: "#fff",
  },
  addUser: {
    height: "55px",
    marginTop: "16px",
    marginLeft: "16px",
  },
  clientsContainer: {
    maxHeight: "120px",
    overflowY: "auto",
    padding: "4px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "3px",
      "&:hover": {
        background: "#a8a8a8",
      },
    },
  },
  tableHeader: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    borderBottom: "2px solid #e0e0e0",
  },
  dealerRow: {
    backgroundColor: "#fafafa",
  },
}));

const AdminDashboard = () => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { profiles } = useSelector((state) => state.profiles);
  const { users } = useSelector((state) => state.auth);
  const { clients: allClients = [] } = useSelector((state) => state.clients || {});
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [openDialog, setOpenDialog] = useState(false);
  const [openViewClientsDialog, setOpenViewClientsDialog] = useState(false);
  const [viewingClients, setViewingClients] = useState([]);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openSnackbar] = useSnackbar({
    position: 'bottom-right',
    style: {
      backgroundColor: "#333",
      color: "#fff",
      fontSize: "16px",
      textAlign: "center",
    }
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();

  // Assign Clients Dialog State
  const [openAssignClientsDialog, setOpenAssignClientsDialog] = useState(false);
  const [assignClientsLoading, setAssignClientsLoading] = useState(false);
  const [availableClients, setAvailableClients] = useState([]);
  const [clientsSearchQuery, setClientsSearchQuery] = useState("");
  const [debouncedClientsSearch, setDebouncedClientsSearch] = useState("");
  const [clientsPage, setClientsPage] = useState(0);
  const [clientsHasMore, setClientsHasMore] = useState(true);
  const [selectedClientIds, setSelectedClientIds] = useState([]);
  const [assignClientsLoadingList, setAssignClientsLoadingList] = useState(false);

  useEffect(() => {
    dispatch(getProfiles());
    dispatch(getAllClients());
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(getUsers({ includeClients: true }));
  }, [location, dispatch]);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleUsernameClick = (id) => history.push(`/userStats/${id}`);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleOpenPasswordDialog = (user) => {
    setSelectedUser(user);
    setOpenPasswordDialog(true);
  };

  const handleClosePasswordDialog = () => {
    setOpenPasswordDialog(false);
    setSelectedUser(null);
  };

  const handleOpenViewClientsDialog = (clients) => {
    let viewClients = clients;
    // When selectedClients is null/undefined/empty, show all clients with "All Clients" indicator
    if (!Array.isArray(viewClients) || viewClients.length === 0) {
      viewClients = allClients.map(c => ({ ...c, __allClients: true }));
    }
    setViewingClients(viewClients || []);
    setOpenViewClientsDialog(true);
  };

  const handleCloseViewClientsDialog = () => {
    setOpenViewClientsDialog(false);
    setViewingClients([]);
  };

  // Assign Clients Handlers
  const handleOpenAssignClientsDialog = (user) => {
    setSelectedUser(user);
    const existingClientIds = user?.selectedClients?.map(client =>
      typeof client === "string" ? client : client._id
    ) || [];
    setSelectedClientIds(existingClientIds);
    setAvailableClients([]);
    setClientsPage(0);
    setClientsHasMore(true);
    setClientsSearchQuery("");
    setDebouncedClientsSearch("");
    setOpenAssignClientsDialog(true);
  };

  const handleCloseAssignClientsDialog = () => {
    setOpenAssignClientsDialog(false);
    setSelectedUser(null);
    setAvailableClients([]);
    setSelectedClientIds([]);
    setClientsSearchQuery("");
    setDebouncedClientsSearch("");
  };

  // Debounce search query
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedClientsSearch(clientsSearchQuery);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [clientsSearchQuery]);

  // Fetch clients for assign dialog
  useEffect(() => {
    if (!openAssignClientsDialog) return;
    let isCancelled = false;
    const fetchClients = async () => {
      setAssignClientsLoadingList(true);
      try {
        const response = await fetchClientsSearch({
          query: debouncedClientsSearch,
          page: clientsPage,
          limit: debouncedClientsSearch ? 0 : 20,
        });
        const clientsData = response?.data?.data || [];
        const totalItems = response?.data?.totalItems || 0;
        if (isCancelled) return;
        setAvailableClients((prev) =>
          clientsPage === 0 ? clientsData : [...prev, ...clientsData]
        );
        setClientsHasMore(
          debouncedClientsSearch ? false : (clientsPage + 1) * 20 < totalItems
        );
      } catch (error) {
        if (!isCancelled) {
          setAvailableClients([]);
          setClientsHasMore(false);
        }
      } finally {
        if (!isCancelled) {
          setAssignClientsLoadingList(false);
        }
      }
    };
    fetchClients();
    return () => {
      isCancelled = true;
    };
  }, [openAssignClientsDialog, debouncedClientsSearch, clientsPage]);

  const handleClientListScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    const isNearBottom = scrollHeight - scrollTop <= clientHeight + 40;
    if (isNearBottom && clientsHasMore && !assignClientsLoadingList) {
      setClientsPage((prev) => prev + 1);
    }
  };

  const handleClientCheckboxChange = (client) => {
    setSelectedClientIds((prev) => {
      const clientId = client._id;
      if (prev.includes(clientId)) {
        return prev.filter((id) => id !== clientId);
      } else {
        return [...prev, clientId];
      }
    });
  };

  const handleSaveAssignedClients = async () => {
    if (!selectedUser) return;
    setAssignClientsLoading(true);
    try {
      await dispatch(
        updateUser(selectedUser._id, { selectedClients: selectedClientIds }, openSnackbar)
      );
      openSnackbar(`Clients assigned successfully to ${selectedUser.name}`);
      handleCloseAssignClientsDialog();
      dispatch(getUsers({ includeClients: true }));
    } catch (error) {
      openSnackbar("Failed to assign clients");
    } finally {
      setAssignClientsLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setSearchQuery("");
    setPage(0);
  };

  const handleDeleteUser = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this User?"
    );
    if (confirmDelete) {
      dispatch(deleteUser(id, openSnackbar));
      const toBeDeleteProfile = profiles.find(
        (profile) => profile.userId[0] === id
      );
      if (toBeDeleteProfile) {
        dispatch(deleteProfile(toBeDeleteProfile._id, openSnackbar));
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  const tabConfigs = [
    { label: "All Users", type: "all" },
    { label: "Admins", type: "admin" },
    { label: "Salespersons", type: "user" },
    { label: "Dealers", type: "dealer" },
  ];

  const currentTabType = tabConfigs[tabValue]?.type;
  const normalizedSearchQuery = searchQuery.trim().toLowerCase();
  const searchTerms = normalizedSearchQuery.split(/\s+/).filter(Boolean);

  const getAssignedClientSearchText = (row) => {
    if (!Array.isArray(row.selectedClients) || row.selectedClients.length === 0) {
      return row.userType === "dealer" || row.userType === "user"
        ? "all clients default all clients visible no clients assigned"
        : "";
    }

    return row.selectedClients
      .map((client) => {
        if (typeof client === "string") return client;
        return [
          client?.name,
          client?.phone,
          client?.address,
          client?.contactPerson,
        ]
          .filter(Boolean)
          .join(" ");
      })
      .join(" ");
  };

  const getUserSearchText = (row) => {
    const baseFields = [
      row?.name,
      row?.email,
      row?.phone,
      row?.userType,
      row?.isActive ? "active enabled" : "inactive disabled",
    ];

    if (row?.userType === "dealer" || row?.userType === "user") {
      baseFields.push(getAssignedClientSearchText(row));
    }

    return baseFields
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  };

  // Filter and process users for table display
  const filteredRows = users.filter((row) => {
    const matchesType = currentTabType === "all" || row.userType === currentTabType;

    if (!matchesType) {
      return false;
    }

    if (!searchTerms.length) {
      return true;
    }

    const searchableText = getUserSearchText(row);
    return searchTerms.every((term) => searchableText.includes(term));
  });

  // For chip coloring all-clients
  const ALL_CLIENTS_INDICATOR_CHIP = (
    <Chip
      label="All Clients"
      size="small"
      style={{
        fontSize: '0.7rem',
        backgroundColor: '#e3f2fd',
        color: '#1976d2',
        fontWeight: '500',
        borderStyle: "dashed"
      }}
    />
  );

  return (
    <div>
      <Container
        style={{
          width: isMobile ? "100%" : "90%",
          paddingTop: "80px",
          paddingBottom: "2px",
          border: "none",
          minHeight: isMobile ? 740 : "510px",
        }}
      >
        <div className={classes.deviceIdTextField}>
          <AdminRow user={user} openSnackbar={openSnackbar} />
        </div>
        <div className={classes.addButton}>
          <TextField
            id="search-bar"
            label="Search Users"
            variant="outlined"
            margin="normal"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setPage(0);
            }}
            placeholder={
              currentTabType === "admin"
                ? "Search by name or email"
                : currentTabType === "user"
                  ? "Search by name, email, phone, assigned client"
                  : currentTabType === "dealer"
                    ? "Search by dealer name, phone, assigned client"
                    : "Search by name, email, phone, type, assigned client"
            }
            helperText={
              currentTabType === "admin"
                ? "Matches admin name and email"
                : currentTabType === "user"
                  ? "Matches salesperson name, email/phone, status, and assigned clients"
                  : currentTabType === "dealer"
                    ? "Matches dealer name, phone, status, and assigned clients"
                    : "Matches all users by name, email/phone, type, status, and assigned clients"
            }
          />
          <Button
            variant="outlined"
            style={{ color: "#ef7f1a", borderColor: "#ef7f1a" }}
            startIcon={<AddIcon />}
            onClick={handleOpenDialog}
            className={classes.addUser}
          >
            Add User
          </Button>
        </div>
        <div className={classes.root}>
          <Paper
            elevation={2}
            style={{
              marginBottom: theme.spacing(2),
              borderRadius: "8px",
              overflow: "hidden"
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              {tabConfigs.map((config, index) => {
                const count = users.filter(user =>
                  config.type === "all" ? true : user.userType === config.type
                ).length;
                return (
                  <Tab
                    key={index}
                    label={
                      <Box display="flex" alignItems="center" gap={1}>
                        <span>{config.label}</span>
                        <Chip
                          label={count}
                          size="small"
                          color={count > 0 ? "primary" : "default"}
                          style={{
                            minWidth: "24px",
                            height: "20px",
                            fontSize: "0.7rem"
                          }}
                        />
                      </Box>
                    }
                    style={{
                      textTransform: "none",
                      fontWeight: "500",
                      minHeight: "48px"
                    }}
                  />
                );
              })}
            </Tabs>
          </Paper>
          <Paper elevation={1} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeader}>ID</TableCell>
                  <TableCell className={classes.tableHeader}>Name</TableCell>
                  <TableCell className={classes.tableHeader}>Email/Phone</TableCell>
                  <TableCell className={classes.tableHeader}>Active</TableCell>
                  <TableCell className={classes.tableHeader}>Type</TableCell>
                  {(tabConfigs[tabValue]?.type === "dealer" || tabConfigs[tabValue]?.type === "user") && (
                    <TableCell className={classes.tableHeader}>Assigned Clients</TableCell>
                  )}
                  <TableCell className={classes.tableHeader}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? filteredRows.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  : filteredRows
                ).map((user, index) => (
                  <TableRow
                    key={user._id}
                    className={user?.userType === "dealer" ? classes.dealerRow : ""}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell
                      onClick={() => {
                        handleUsernameClick(user._id);
                      }}
                      style={{ cursor: "pointer", fontWeight: "500" }}
                    >
                      {user.name}
                    </TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      {user?.userType === "admin" ? null : (
                        <UserRow user={user} />
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={user?.userType === "admin" ? "Admin" :
                          user?.userType === "dealer" ? "Dealer" : "Salesperson"}
                        color={user?.userType === "admin" ? "primary" :
                          user?.userType === "dealer" ? "secondary" : "default"}
                        size="small"
                        style={{ fontWeight: "bold" }}
                      />
                    </TableCell>
                    {(tabConfigs[tabValue]?.type === "dealer" || tabConfigs[tabValue]?.type === "user") && (
                      <TableCell>
                        <Box display="flex" alignItems="center" gap={1}>
                          {(Array.isArray(user.selectedClients) && user.selectedClients.length > 0) ? (
                            <>
                              <div className={classes.clientsContainer}>
                                <Box display="flex" flexWrap="wrap" gap={0.5}>
                                  {user.selectedClients.slice(0, 2).map((client, clientIndex) => (
                                    <Chip
                                      key={client._id || clientIndex}
                                      label={client.name || `Client ${clientIndex + 1}`}
                                      size="small"
                                      style={{
                                        fontSize: '0.7rem',
                                        backgroundColor: tabConfigs[tabValue]?.type === "dealer" ? '#e3f2fd' : '#e8f5e9',
                                        color: tabConfigs[tabValue]?.type === "dealer" ? '#1976d2' : '#2e7d32',
                                        fontWeight: '500'
                                      }}
                                    />
                                  ))}
                                  {user.selectedClients.length > 2 && (
                                    <Chip
                                      label={`+${user.selectedClients.length - 2} more`}
                                      size="small"
                                      style={{
                                        fontSize: '0.7rem',
                                        backgroundColor: '#f5f5f5',
                                        color: '#666',
                                        fontWeight: '500'
                                      }}
                                    />
                                  )}
                                </Box>
                              </div>
                              <IconButton
                                size="small"
                                onClick={() => handleOpenViewClientsDialog(user.selectedClients)}
                                style={{
                                  padding: '4px',
                                  color: '#ef7f1a',
                                  marginLeft: '8px'
                                }}
                                title="View all assigned clients"
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              {Array.isArray(allClients) && allClients.length > 0 ? (
                                <>
                                  <div className={classes.clientsContainer} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    {ALL_CLIENTS_INDICATOR_CHIP}
                                    <Chip
                                      label={"Default: all clients visible"}
                                      size="small"
                                      color="default"
                                      style={{
                                        fontSize: '0.7rem',
                                        marginLeft: 4,
                                        backgroundColor: '#f0f0f0',
                                        color: '#888',
                                      }}
                                    />
                                  </div>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenViewClientsDialog([])}
                                    style={{
                                      padding: '4px',
                                      color: '#ef7f1a',
                                      marginLeft: '8px'
                                    }}
                                    title="Show all clients"
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </>
                              ) : (
                                <>
                                  <Chip
                                    label="No clients assigned"
                                    size="small"
                                    color="secondary"
                                    variant="outlined"
                                    style={{ fontSize: '0.7rem' }}
                                  />
                                  <IconButton
                                    size="small"
                                    disabled
                                    style={{
                                      padding: '4px',
                                      marginLeft: '8px'
                                    }}
                                    title="No clients to view"
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </>
                              )}
                            </>
                          )}
                        </Box>
                      </TableCell>
                    )}
                    <TableCell>
                      {user?.userType === "admin" ? null : (
                        <Box display="flex" alignItems="center" gap={1}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              handleOpenPasswordDialog(user);
                            }}
                            style={{
                              color: "#1976D2",
                              backgroundColor: "#e3f2fd",
                              padding: '8px',
                              marginRight: '4px'
                            }}
                            title="Change password"
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          {(user?.userType === "user" ) && (
                            <IconButton
                              size="small"
                              onClick={() => {
                                handleOpenAssignClientsDialog(user);
                              }}
                              style={{
                                color: "#2e7d32",
                                backgroundColor: "#e8f5e9",
                                padding: '8px',
                                marginRight: '4px'
                              }}
                              title="Assign clients"
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          )}
                          <IconButton
                            size="small"
                            onClick={() => {
                              handleDeleteUser(user._id);
                            }}
                            style={{
                              color: "#ef7f1a",
                              backgroundColor: "#fff3e0",
                              padding: '8px'
                            }}
                            title="Delete user"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell
                    colSpan={
                      (tabConfigs[tabValue]?.type === "dealer" ||
                        tabConfigs[tabValue]?.type === "user")
                        ? 7
                        : 6
                    }
                  >
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "All", value: -1 },
                      ]}
                      count={filteredRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </Paper>
          <Dialog
            aria-labelledby="customized-dialog-title"
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="md"
            fullWidth
            PaperProps={{
              style: { height: "90vh", borderRadius: 12, overflow: "hidden" },
            }}
          >
            <DialogTitle
              className={classes.dialogTitle}
              id="customized-dialog-title"
              style={{ backgroundColor: "#ef7f1a" }}
            >
              Add User
            </DialogTitle>
            <DialogContent style={{ padding: 0, height: "calc(100% - 64px)" }}>
              <AdminLogin />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="primary" style={{ marginRight: "auto" }}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        {/* View Clients Dialog */}
        <Dialog
          open={openViewClientsDialog}
          onClose={handleCloseViewClientsDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DialogTitle
            style={{
              backgroundColor: "#ef7f1a",
              color: "white",
              fontWeight: "bold",
              fontSize: "1.2rem",
              padding: "16px 24px",
            }}
          >
            Assigned Clients
          </DialogTitle>
          <DialogContent style={{ padding: "24px" }}>
            {viewingClients.length > 0 ? (
              <List>
                {viewingClients.map((client, index) => (
                  <React.Fragment key={client._id || index}>
                    <ListItem
                      style={{
                        padding: "12px 0",
                        borderBottom:
                          index < viewingClients.length - 1
                            ? "1px solid #f0f0f0"
                            : "none",
                        alignItems: "flex-start",
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="subtitle1"
                            style={{
                              fontWeight: "600",
                              color: "#333",
                              fontSize: "1rem",
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            {client.__allClients
                              ? <>
                                <span>{client.name}</span>
                                {ALL_CLIENTS_INDICATOR_CHIP}
                              </>
                              : (client.name || `Client ${index + 1}`)
                            }
                          </Typography>
                        }
                        secondary={
                          <Box style={{ marginTop: "4px" }}>
                            {client.phone && (
                              <Typography
                                variant="body2"
                                style={{ color: "#666", fontSize: "0.9rem" }}
                              >
                                📞 {client.phone}
                              </Typography>
                            )}
                            {client.contactPerson && (
                              <Typography
                                variant="body2"
                                style={{ color: "#666", fontSize: "0.9rem" }}
                              >
                                👤 {client.contactPerson}
                              </Typography>
                            )}
                            {client.address && (
                              <Typography
                                variant="body2"
                                style={{ color: "#666", fontSize: "0.9rem" }}
                              >
                                📍 {client.address}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                  </React.Fragment>
                ))}
              </List>
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{ padding: "40px 20px" }}
              >
                <Typography
                  variant="h6"
                  style={{
                    color: "#999",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  No clients assigned
                </Typography>
                <Typography
                  variant="body2"
                  style={{ color: "#bbb", textAlign: "center" }}
                >
                  This dealer doesn't have any clients assigned yet.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px", backgroundColor: "#fafafa" }}>
            <Button
              onClick={handleCloseViewClientsDialog}
              style={{
                backgroundColor: "#ef7f1a",
                color: "white",
                fontWeight: "600",
                padding: "8px 24px",
                borderRadius: "6px",
                textTransform: "none",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Change Password Dialog */}
        <ChangePassword
          open={openPasswordDialog}
          onClose={handleClosePasswordDialog}
          user={selectedUser}
          title="Change Password"
        />

        {/* Assign Clients Dialog */}
        <Dialog
          open={openAssignClientsDialog}
          onClose={handleCloseAssignClientsDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              maxHeight: "80vh",
            },
          }}
        >
          <DialogTitle
            style={{
              backgroundColor: "#ef7f1a",
              color: "white",
              fontWeight: "bold",
              fontSize: "1.2rem",
              padding: "16px 24px",
            }}
          >
            Assign Clients to {selectedUser?.name}
          </DialogTitle>
          <DialogContent style={{ padding: "0", display: "flex", flexDirection: "column" }}>
            {/* Search Bar and Select All */}
            <Box p={2} style={{ borderBottom: "1px solid #e0e0e0", display: "flex", gap: "8px", alignItems: "center" }}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search clients..."
                value={clientsSearchQuery}
                onChange={(e) => setClientsSearchQuery(e.target.value)}
                style={{ flex: 1 }}
              />
              <Box display="none" gap={1}>
              </Box>
            </Box>
            <Box
              style={{
                flex: 1,
                overflow: "auto",
                maxHeight: "400px",
                padding: "8px",
              }}
              onScroll={handleClientListScroll}
            >
              {assignClientsLoadingList && availableClients.length === 0 ? (
                <Box display="flex" justifyContent="center" p={3}>
                  <CircularProgress size={24} />
                </Box>
              ) : availableClients.length === 0 ? (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  p={4}
                >
                  <Typography variant="body1" color="textSecondary">
                    No clients found
                  </Typography>
                </Box>
              ) : (
                <List>
                  {availableClients.map((client) => {
                    const isSelected = selectedClientIds.includes(client._id);
                    return (
                      <ListItem
                        key={client._id}
                        onClick={() => handleClientCheckboxChange(client)}
                        style={{
                          cursor: "pointer",
                          borderRadius: "8px",
                          marginBottom: "4px",
                          backgroundColor: isSelected ? "#fff3e0" : "transparent",
                          border: isSelected ? "1px solid #ef7f1a" : "1px solid transparent",
                        }}
                      >
                        <Checkbox
                          checked={isSelected}
                          onClick={(e) => e.stopPropagation()}
                          onChange={() => handleClientCheckboxChange(client)}
                          style={{ marginRight: "8px", color: "#ef7f1a" }}
                        />
                        <ListItemText
                          primary={
                            <Typography variant="subtitle1" style={{ fontWeight: "600" }}>
                              {client.name}
                            </Typography>
                          }
                          secondary={
                            <Box>
                              {client.phone && (
                                <Typography variant="body2" color="textSecondary">
                                  📞 {client.phone}
                                </Typography>
                              )}
                              {client.address && (
                                <Typography variant="body2" color="textSecondary" noWrap>
                                  📍 {client.address}
                                </Typography>
                              )}
                            </Box>
                          }
                        />
                        {isSelected && (
                          <Chip
                            label="Selected"
                            size="small"
                            style={{
                              backgroundColor: "#ef7f1a",
                              color: "white",
                              fontWeight: "500",
                            }}
                          />
                        )}
                      </ListItem>
                    );
                  })}
                  {assignClientsLoadingList && (
                    <Box display="flex" justifyContent="center" p={2}>
                      <CircularProgress size={24} />
                    </Box>
                  )}
                </List>
              )}
            </Box>
            {/* Selected Count */}
            <Box
              p={2}
              style={{
                borderTop: "1px solid #e0e0e0",
                backgroundColor: "#fafafa",
              }}
            >
              <Typography variant="body2" style={{ fontWeight: "500" }}>
                Selected: {selectedClientIds.length} client(s)
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px", backgroundColor: "#fafafa" }}>
            <Button
              onClick={handleCloseAssignClientsDialog}
              style={{
                color: "#666",
                fontWeight: "600",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSaveAssignedClients}
              disabled={assignClientsLoading}
              style={{
                backgroundColor: "#ef7f1a",
                color: "white",
                fontWeight: "600",
                padding: "8px 24px",
                borderRadius: "6px",
                textTransform: "none",
              }}
            >
              {assignClientsLoading ? (
                <CircularProgress size={20} style={{ color: "white" }} />
              ) : (
                "Save Assignment"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </div>
  );
};

export default AdminDashboard;
